import sys from "./modules/sys";
import sysUser from './modules/sysUser'
import sysPermission from './modules/sysPermission';
import contact from './modules/contact'
import askForCode from './modules/askForCode'

export default {
  sys,sysUser,sysPermission,contact,askForCode
}



// WEBPACK FOOTER //
// ./src/api/api.js